import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, CheckCircle2, Gift } from 'lucide-react';
export function Bonuses() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const bonuses = [{
    id: 1,
    emoji: '⚽',
    title: 'Banco de Ejercicios Técnicos',
    description: '+80 ejercicios técnicos con descripción, variantes y objetivos claros. Nunca más repetir los mismos 10 ejercicios de siempre.',
    bullets: ['Ejercicios de pase y recepción por nivel', 'Control, conducción y protección del balón', 'Remate y definición específica para mujeres', 'Juego aéreo y disputas', 'Variantes de dificultad por ejercicio', 'Indicaciones de espacio, tiempo y jugadoras necesarias', 'Objetivos técnicos claramente definidos por ejercicio', 'Integración con trabajo físico dentro del campo']
  }, {
    id: 2,
    emoji: '🦵',
    title: 'Protocolo Anti-Lesiones',
    description: 'Rutinas de prevención específicas para la mujer futbolista. El bono que puede salvar la temporada de tus jugadoras.',
    bullets: ['Protocolo específico para rodilla y LCA en la mujer', 'Prevención de lesiones de tobillo y cadera', 'Rutinas de entrada en calor preventiva', 'Vuelta a la actividad post-lesión paso a paso', 'Ejercicios de propiocepción y estabilización', 'Señales de alerta que todo entrenador debe conocer', 'Protocolo de emergencia en el campo', 'Cuándo derivar y a quién']
  }, {
    id: 3,
    emoji: '📋',
    title: 'Plantillas de Planificación Editables',
    description: 'Plantillas en PDF listas para completar semana a semana. El soporte operativo que hace que todo funcione en la práctica.',
    bullets: ['Plantilla de microciclo semanal completo', 'Control y registro de cargas de entrenamiento', 'Registro de asistencia y seguimiento de jugadoras', 'Planilla de evaluación técnica individual', 'Hoja de sesión lista para completar', 'Calendario de temporada editable', 'Registro de análisis de partido propio y rival', 'Formato imprimible o para completar en tablet']
  }, {
    id: 4,
    emoji: '📊',
    title: 'Test de Evaluación del Plantel',
    description: 'Sistema completo para evaluar el nivel físico y técnico de tus jugadoras. Conocé con datos reales el nivel de cada una.',
    bullets: ['Tests físicos adaptados a la mujer futbolista', 'Evaluación técnica por posición', 'Tablas de referencia por categoría', 'Cómo interpretar y usar los resultados en tu planificación', 'Cómo comunicar los resultados a las jugadoras', 'Planilla de seguimiento de evolución mensual', 'Re-test para medir progreso real', 'Cómo ajustar la planificación según los resultados']
  }, {
    id: 5,
    emoji: '🥗',
    title: 'Guía de Nutrición para la Jugadora',
    description: 'Lo que todo entrenador debe saber sobre alimentación femenina en el deporte. Sin ser nutricionista.',
    bullets: ['Nutrición específica para la mujer deportista', 'Qué comer antes, durante y después del entrenamiento', 'Hidratación y rendimiento en el campo', 'Deficiencia de hierro: el problema más común en la mujer deportista', 'Cómo hablar de alimentación con tus jugadoras', 'Señales de alarma que el entrenador debe conocer', 'Cuándo y cómo derivar a un especialista', 'Mitos y verdades de la nutrición deportiva femenina']
  }, {
    id: 6,
    emoji: '💼',
    title: 'El Entrenador Completo',
    description: 'Guía de desarrollo profesional para entrenadores de fútbol femenino. El mercado está creciendo. Este bono te prepara para aprovecharlo.',
    bullets: ['Cómo posicionarte como referente en fútbol femenino', 'Cómo conseguir tu primer trabajo como DT', 'Cómo crecer dentro de un club', 'Redes sociales y marca personal para entrenadores', 'Cómo dar charlas técnicas que te posicionen', 'El fútbol femenino en Argentina: panorama y oportunidades reales', 'Cómo armar tu carpeta profesional', 'Networking en el fútbol femenino argentino']
  }];
  return <section className="py-8 md:py-20 px-3 md:px-4 bg-navy text-white relative overflow-hidden" data-id="element-16">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brandGreen/5 blur-[120px] rounded-full pointer-events-none" data-id="element-17"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-18">
        <div className="text-center mb-5 md:mb-16" data-id="element-19">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center justify-center bg-brandGreen/20 text-brandGreen font-bold px-4 md:px-6 py-1.5 md:py-2 rounded-full mb-3 md:mb-6 shadow-[0_0_20px_rgba(34,197,94,0.2)] text-sm md:text-base" data-id="element-20">
            <Gift className="w-4 h-4 md:w-5 md:h-5 mr-2" data-id="element-21" />
            INCLUIDOS GRATIS
          </motion.div>
          <h2 className="text-2xl md:text-5xl font-black mb-2 md:mb-4" data-id="element-22">
            6 Bonos Estratégicos
          </h2>
          <p className="text-sm md:text-xl text-gray-400 font-medium max-w-2xl mx-auto" data-id="element-23">
            Herramientas complementarias de alto valor para profesionalizar cada
            aspecto de tu gestión.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-8 mb-8 md:mb-16" data-id="element-24">
          {bonuses.map((bono, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-navy-light rounded-2xl md:rounded-3xl border border-brandGreen/20 relative overflow-hidden group hover:border-brandGreen/60 transition-all duration-300 shadow-[0_0_15px_rgba(34,197,94,0.05)] hover:shadow-[0_0_30px_rgba(34,197,94,0.15)] flex flex-col" data-id="element-25">
              {/* Subtle gradient background per card */}
              <div className="absolute -top-20 -right-20 w-48 h-48 bg-brandGreen/10 blur-3xl rounded-full group-hover:bg-brandGreen/20 transition-colors duration-500" data-id="element-26"></div>

              <div className="p-4 md:p-8 flex-grow relative z-10" data-id="element-27">
                <div className="flex justify-between items-start mb-3 md:mb-6" data-id="element-28">
                  <div className="text-3xl md:text-6xl drop-shadow-lg transform group-hover:scale-110 transition-transform duration-300" data-id="element-29">
                    {bono.emoji}
                  </div>
                  <span className="bg-brandGreen text-navy text-[10px] md:text-sm font-black px-2 md:px-3 py-1 md:py-1.5 rounded-lg uppercase tracking-wider shadow-lg flex items-center gap-1" data-id="element-30">
                    BONO {bono.id} <span className="opacity-50" data-id="element-31">•</span> GRATIS
                  </span>
                </div>
                <h3 className="text-base md:text-2xl font-black text-white mb-1.5 md:mb-3 leading-tight" data-id="element-32">
                  {bono.title}
                </h3>
                <p className="text-xs md:text-base text-gray-300 leading-relaxed font-medium" data-id="element-33">
                  {bono.description}
                </p>
              </div>

              <div className="border-t border-white/10 relative z-10 bg-navy-dark/50" data-id="element-34">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-4 md:px-8 py-2.5 md:py-4 flex items-center justify-between text-xs md:text-base font-bold text-brandGreen hover:bg-white/5 transition-colors focus:outline-none" data-id="element-35">
                  <span data-id="element-36">Ver detalles del bono</span>
                  <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-37" />
                </button>

                <AnimatePresence data-id="element-38">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-39">
                      <div className="px-4 md:px-8 pb-4 md:pb-6 pt-1 md:pt-2 border-t border-white/5" data-id="element-40">
                        <ul className="space-y-2 md:space-y-3" data-id="element-41">
                          {bono.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-2 md:gap-3" data-id="element-42">
                              <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-brandGreen flex-shrink-0 mt-0.5" data-id="element-43" />
                              <span className="text-gray-300 text-xs md:text-base" data-id="element-44">
                                {bullet}
                              </span>
                            </li>)}
                        </ul>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brandGreen text-navy text-center p-4 md:p-8 rounded-2xl md:rounded-3xl font-black text-lg md:text-3xl shadow-[0_0_40px_rgba(34,197,94,0.3)] max-w-4xl mx-auto border-4 border-brandGreen-hover" data-id="element-45">
          VALOR TOTAL DE LOS 6 BONOS $56.000 <br className="md:hidden" data-id="element-46" />
          <span className="bg-navy text-white px-3 md:px-4 py-1 md:py-1.5 rounded-xl mx-2 md:mx-3 text-base md:text-2xl align-middle shadow-inner" data-id="element-47">
            GRATIS
          </span>
          <span className="font-bold text-base md:text-2xl opacity-90" data-id="element-48">
            — Incluidos siempre
          </span>
        </motion.div>
      </div>
    </section>;
}